export const Types = {
    CREATE_APPOINTMENT: "CREATE_APPOINTMENT",
    EDIT_APPOINTMENT: "EDIT_APPOINTMENT",
    LIST_APPOINTMENTS: "LIST_APPOINTMENTS"
  };